import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./Dashboard";
import Agents from "./Agents";
import Clients from "./Clients";
import Settings from "./Settings";
import ManageProducts from "./ManageProducts";
import ManageArchived from "./ManageArchived";
import EmailMarketing from "./EmailMarketing";
import CombinedForm from "../forms/CombinedForm";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />

      <Route path="agents" element={<Agents />} />

      <Route path="clients" element={<Clients />} />

      <Route path="offer" element={<CombinedForm />} />

      <Route path="requests" element={<ManageProducts />} />

      <Route path="archived" element={<ManageArchived />} />

      <Route path="emails" element={<EmailMarketing />} />

      <Route path="settings" element={<Settings />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AdminRoutes;
